import {Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {MatSnackBar} from '@angular/material';
import {ConfService} from '../../conf.service';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {LeftpanelNewComponent} from '../../leftpanel-new/leftpanel-new.component';
import {AddDevexConfigurationNewComponent} from './add-devex-configuration-new/add-devex-configuration-new.component';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';
import {interval} from 'rxjs';
import {AccountInfoService} from '../../user/account-info.service';

export interface DeveloperSettingsData {
  default: boolean;
  name: string;
  url: string;
  cloud: string;
  primaryRegion: string;
  regions: string[];
  status: string;
}
@Component({
  selector: 'app-developer-settings-new',
  templateUrl: './developer-settings-new.component.html',
  styleUrls: ['./developer-settings-new.component.scss']
})

export class DeveloperSettingsNewComponent implements OnInit {

  displayedColumns: string[] = [
    'default',
    'name',
    'url',
    'cloud',
    'primaryRegion',
    'regions',
    'status',
    'actions',
  ];

  componentData: any;
  totalServices: any;
  settingsData: any;
  environment: any;
  selectedEnvironment: any;
  originalData:any

  selectedElement: any;
  dataSource: any;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  componentLoading = true;

  cloud_options = [
    { value: 'aws', label: 'Amazon Web Service', logo: 'assets/img/cloud/aws-logo.png', width: '20px', height: '13px' },
    { value: 'azure', label: 'Microsoft Azure', logo: 'assets/img/cloud/azure-logo.png', width: '25px', height: '15px' },
    { value: 'gcp', label: 'Google Cloud Platform', logo: 'assets/img/cloud/gcp-logo.webp', width: '20px', height: '15px' },
  ];

  primaryRegionOptions: { [key: string]: string[] } = {
    aws: ['US East (Ohio)', 'US East (N. Virginia)', 'US West (N. California)', 'US West (Oregon)','Africa (Cape Town)','Asia Pacific (Hong Kong)','Asia Pacific (Hyderabad)','Asia Pacific (Jakarta)', 'Asia Pacific (Melbourne)','Asia Pacific (Mumbai)',
    'Asia Pacific (Osaka)','Asia Pacific (Seoul)','Asia Pacific (Singapore)','Asia Pacific (Sydney)','Asia Pacific (Tokyo)','Canada (Central)','Canada West (Calgary)','Europe (Frankfurt)','Europe (Ireland)','Europe (London)','Europe (Milan)','Europe (Paris)',
    'Europe (Spain)','Europe (Stockholm)', 'Europe (Zurich)', 'Israel (Tel Aviv)', 
    'Middle East (Bahrain)','Middle East (UAE)','South America (São Paulo)',
    'AWS GovCloud (US-East)','AWS GovCloud (US-West)'],
    azure: ['East Asia', 'Southeast Asia','Australia Central','Australia East','Australia Southeast','China East','China East 2','China North','China North 2','China North 3','Central India','India South Central','South India','Indonesia Central','Japan East','Japan West',
    'Korea Central','Malaysia West','New Zealand North','Saudi Arabia Central','Taiwan North'],
    gcp: ['US Central1 (Iowa)', 'US East4 (N. Virginia)', 'Europe West2 (London)','Europe West4 (Netherlands)'],
  };

  constructor(
      public platform: LeftpanelNewComponent,
      private snackBar: MatSnackBar,
      private dialog: MatDialog,
      private confPost: ConfService,
      public accountInfoService: AccountInfoService,
      public adminEnvironmenthandler: AdminEnvironmentHandlerService,
      private partnerSettingsService: PartnerSettingsService
  ) { }

  getCloudInfo(cloud: string) {

    const selectedOption = this.cloud_options.find(option => option.value === cloud);
    return {
      logo: selectedOption.logo,
      label: selectedOption.label,
      width: selectedOption.width,
      height: selectedOption.height
    };
  }

  onCloudChange(i)
  {
    const data = this.dataSource.data[i]
    // console.log(data);
    data.regions=[]
  }

  copyMessage(url) {
    const val = url.startsWith('https') ? url : `https://${url}`;
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val; // Assign the string directly
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.platform.openSnackBar('Copied to clipboard.', 'Success', {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  editToggle(i) {
    this.originalData = { ...this.dataSource['data'][i] };
    this.dataSource['data'][i]['regions'] = [...this.originalData.regions];
    this.dataSource['data'][i]['isEdit'] = !this.dataSource['data'][i]['isEdit'];
  }

  cancelEdit(i: number) {
    this.dataSource['data'][i]['isEdit'] = false;
    this.dataSource['data'][i] = { ...this.originalData };
  }

  isValidUrl(url: string): boolean {
    const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*$/;
    return urlPattern.test(url);
  }

  editConfiguration(i) {
    if (this.totalServices) {
      this.dataSource['data'][i]['isEdit'] = !this.dataSource['data'][i]['isEdit'];
      for (const val of this.dataSource.data) {
        delete val['isEdit'];
      }
      const temp = this.totalServices.filter((service) => service.name === 'Developer Experience');
      if (temp && temp.length > 0) {
        temp[0]['configurations'][i] = this.dataSource['data'][i];
      }
      this.componentData['configurations'] = temp[0]['configurations'];
      const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['env']);
      if (temp1 && temp1.length > 0) {
        temp1[0]['services'] = this.totalServices;
      }
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });

      this.confPost.patchEntityData('services',
          'services',
          'v2',
          'settings',
          this.settingsData['id'],
          this.settingsData).subscribe(resp => {
        if (resp) {
          this.snackBar.open( 'Configuration updated successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.initialize('DeveloperExperience');
        }
        loaderDialog.close();
      }, error => {
        this.snackBar.open( 'Error while updating configuration.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
      });
    }
  }

  removeConfiguration(i) {
    if (this.totalServices) {
      const temp = this.totalServices.filter((service) => service.name === 'Developer Experience');
      if (temp && temp.length > 0) {
        if (temp[0]['configurations'][i]['is_default'] !== true) {
          if (confirm('This action is irreversible. Are you sure want to remove this configuration?')) {
            for (const val of this.dataSource.data) {
              delete val['isEdit'];
            }
            temp[0]['configurations'].splice(i, 1);
            this.componentData['configurations'] = temp[0]['configurations'];
            const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
            if (temp1 && temp1.length > 0) {
              temp1[0]['services'] = this.totalServices;
            }

            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
              width: 'auto',
              height: 'auto',
            });

            this.confPost.patchEntityData('services',
                'services',
                'v2',
                'settings',
                this.settingsData['id'],
                this.settingsData).subscribe(resp => {
              if (resp) {
                this.snackBar.open( 'Configuration deleted successfully', 'Success', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
                this.initialize('DeveloperExperience');
              }
              loaderDialog.close();
            }, error => {
              this.snackBar.open( 'Error while deleting the configuration.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              loaderDialog.close();
            });
          }
        } else {
          this.snackBar.open('Default configuration cannot be deleted.', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
    }
  }

  add(event, data): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      data.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(val, data): void {
    const index = data.indexOf(val);

    if (index >= 0) {
      data.splice(index, 1);
    }
  }

  changeDefault(event, index) {
    const temp = this.totalServices.filter((service) => service.name === 'Developer Experience');
    if (temp && temp.length > 0) {
      for (const val of this.dataSource.data) {
        delete val['isEdit'];
      }

      for (const config of temp[0]['configurations']) {
        config['is_default'] = false;
      }

      temp[0]['configurations'][index]['is_default'] = true;

      this.componentData['configurations'] = temp[0]['configurations'];
      const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
      if (temp1 && temp1.length > 0) {
        temp1[0]['services'] = this.totalServices;
      }

      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });

      this.confPost.patchEntityData('services',
          'services',
          'v2',
          'settings',
          this.settingsData['id'],
          this.settingsData).subscribe(resp => {
        if (resp) {
          this.snackBar.open( 'Configuration made default successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.initialize('DeveloperExperience');
        }
        loaderDialog.close();
      }, error => {
        this.snackBar.open( 'Error while making the configuration default', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
      });
    }
  }

  addConfiguration() {
    const addConfigurationDialog = this.dialog.open(AddDevexConfigurationNewComponent, {
      width: '60vw',
      height: 'auto',
      panelClass: 'dialog-color',
      data: {
        configuration: {
          regions: [],
          name: '',
          url: '',
          status: '',
          is_default: false,
          cloud: '',
          primary_region: '',
          verification_status: 'created',
          audit_logs: [
            {
              action: 'CREATE',
              by: localStorage.getItem('primary_email'),
              at: Date.now()
            }
          ],
        },
        isEdit: false
      }
    });

    addConfigurationDialog.afterClosed().subscribe(response => {
      if (response) {
        if (this.totalServices) {
          for (const val of this.dataSource.data) {
            delete val['isEdit'];
          }
          const temp = this.totalServices.filter((service) => service.name === 'Developer Experience');
          if (temp && temp.length > 0) {
            temp[0]['configurations'].push(response);
          }
          this.componentData['configurations'] = temp[0]['configurations'];
          const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['env']);
          if (temp1 && temp1.length > 0) {
            temp1[0]['services'] = this.totalServices;
          }

          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
          });

          this.confPost.patchEntityData('services',
              'services',
              'v2',
              'settings',
              this.settingsData['id'],
              this.settingsData).subscribe(resp => {
            if (resp) {
              this.snackBar.open( 'Configuration added successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              this.initialize('DeveloperExperience');
            }
            loaderDialog.close();
          }, error => {
            this.snackBar.open( 'Error while adding the configuration.', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            loaderDialog.close();
          });
        }
      }
    });
  }
  
  getId(id) {
    const str = id.split(' ').join('');
    return str;
  }

  getData(componentKey) {
    this.settingsData = this.partnerSettingsService.settingsData;
    this.totalServices = this.partnerSettingsService.environmentServices;
    this.environment = this.partnerSettingsService.environment;

    this.componentData = this.environment.services.find(service => this.getId(service['name']) === componentKey);
    this.selectedEnvironment = this.adminEnvironmenthandler.currentEnvironment;
    if (this.componentData) {
      this.dataSource = new MatTableDataSource([]);
      for (const val of this.componentData['configurations']) {
        val['isEdit'] = false;
        if (val.is_default === true) {
          this.selectedElement = val;
        }
      }
      this.dataSource.data = this.componentData['configurations'];
    } else {
    }
  }

  initialize(componentKey: any) {

    const partnerSettingsSubscription = interval(500).subscribe((async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        this.getData(componentKey);
        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          this.getData(componentKey);
        });
        this.componentLoading = false;
      } else {
        this.componentLoading = true;
      }
    }));
  }

  refreshPage() {
    this.getData('DeveloperExperience');
  }

  ngOnInit() {
    this.initialize('DeveloperExperience');
  }

}
